import { render } from "./CampoPreenchivel.vue?vue&type=template&id=48399977&scoped=true"
import script from "./CampoPreenchivel.vue?vue&type=script&lang=js"
export * from "./CampoPreenchivel.vue?vue&type=script&lang=js"

import "./CampoPreenchivel.vue?vue&type=style&index=0&id=48399977&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48399977"],['__file',"src/components/VisualizarForm/components/CampoPreenchivel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48399977"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48399977', __exports__)) {
    console.log('reload')
    api.reload('48399977', __exports__)
  }
  
  module.hot.accept("./CampoPreenchivel.vue?vue&type=template&id=48399977&scoped=true", () => {
    console.log('re-render')
    api.rerender('48399977', render)
  })

}


export default __exports__